import React from 'react';
import { Alert, Box } from '@mui/material';
import { noticeSx } from '../../helpers/sx';

type Props = {
  /** Not nullable: a paid funnel always has a number, since that is what the money was for. */
  phoneNumber: string;
};

/**
 * Render only once the funnel has been read: a company the wizard created answers the funnel lookup with a
 * 404, and telling its admin their plan is paid for would be an invention.
 */
export const SignupPaidNotice: React.FC<Props> = ({ phoneNumber }) => (
  <Alert severity="success" sx={noticeSx}>
    {'Your plan is paid for and '}
    <Box component="span" fontWeight="fontWeightSemiBold">
      {phoneNumber}
    </Box>
    {' is yours. What is left is what the carriers ask for before it can send — there is nothing more to pay.'}
  </Alert>
);
